import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { type HsmKeyTypeMappingObj } from '../services/getActiveKeyTypeMappingsList'

export interface InactiveKeyTypeMappingsList {
  isLoading: boolean
  error: string | null
  httpStatus: number | null
  data: HsmKeyTypeMappingObj | null
}

const initialState: InactiveKeyTypeMappingsList = {
  isLoading: false,
  error: null,
  httpStatus: 0,
  data: null
}

const inactiveKeyTypeMappingsListSlice = createSlice({
  name: 'inactiveKeyTypeMappingsList',
  initialState,
  reducers: {
    inactiveKeyTypeMappingsListLoadingAction: (state) => {
      return {
        isLoading: true,
        error: null,
        httpStatus: 0,
        data: null
      }
    },
    inactiveKeyTypeMappingsListUpdateAction: (state, action: PayloadAction<{ data: HsmKeyTypeMappingObj, httpStatus: number }>) => {
      return {
        isLoading: false,
        error: null,
        httpStatus: action.payload.httpStatus,
        data: action.payload.data
      }
    },
    inactiveKeyTypeMappingsListErrorAction: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number }>) => {
      return {
        isLoading: false,
        error: action.payload.errorMessage,
        httpStatus: action.payload.httpStatus,
        data: null
      }
    }
  }
})

export const {
  inactiveKeyTypeMappingsListLoadingAction,
  inactiveKeyTypeMappingsListUpdateAction,
  inactiveKeyTypeMappingsListErrorAction
} = inactiveKeyTypeMappingsListSlice.actions

export default inactiveKeyTypeMappingsListSlice.reducer
